(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__modern"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-mosaic"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class MosaicSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-mosaic]').forEach(($section) => {
  Section.init($section, MosaicSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.MosaicSection = MosaicSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$overlay = this.query('[data-pxu-video-overlay]');
    this.$btn = this.query('[data-pxu-video-btn]');
    this.$shopifyVideo = this.query('.pxu-video__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.initIntersectionObserver();
  }

  onUnmount() {
    this.events.unregisterAll();
    this.observer.unobserve(this.$root);
  }

  initEventListeners() {
    if (this.$btn) {
      this.events.register(this.$btn, 'click', (e) => this.handleClick(e));
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  handleClick(e) {
    e.preventDefault();
    this.$overlay.style.opacity = 0;
    this.$overlay.style.pointerEvents = 'none';

    if (this.data.videoType === 'youtube') {
      const $video = this.query('[data-pxu-video-youtube');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'vimeo') {
      const $video = this.query('[data-pxu-video-vimeo]');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'shopify_hosted') {
      this.$shopifyVideo.play();
      this.$shopifyVideo.setAttribute('controls', '');
    }
  }

  initVideo() {
    switch (this.data.videoType) {
      case 'youtube':
        this.initYouTube();
        break;
      case 'vimeo':
        this.initVimeo();
        break;
      case 'shopify_hosted':
        if (this.data.enableVideoAutoplay) {
          this.$shopifyVideo.play();
        }
        break;
      default:
        console.error('Unsupported video type:', this.data.videoType);
    }
  }

  initYouTube() {
    if (this.data.videoType !== 'youtube') return;
    const $ytPlaceholder = this.query('[data-youtube-placeholder]');
    const ytAttributeString = $ytPlaceholder.dataset.attributeString;
    const ytTitle = $ytPlaceholder.dataset.title;
    $ytPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://www.youtube.com/embed/${this.data.videoId}?${ytAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        title="${ytTitle}"
        data-pxu-video-youtube
      ></iframe>
    `;
  }

  initVimeo() {
    if (this.data.videoType !== 'vimeo') return;
    const $vimeoPlaceholder = this.query('[data-vimeo-placeholder]');
    const vimeoAttributeString = $vimeoPlaceholder.dataset.attributeString;
    $vimeoPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://player.vimeo.com/video/${this.data.videoId}?${vimeoAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        data-pxu-video-vimeo
      ></iframe>
    `;
  }
}

document.querySelectorAll('[data-pxu-video]').forEach(($section) => {
  Section.init($section, VideoSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoSection = VideoSection;
}

  } catch(e) { console.error(e); }
})();
})();
